import { render, staticRenderFns } from "./PlanCaseIssueList.vue?vue&type=template&id=1de3bbec&scoped=true"
import script from "./PlanCaseIssueList.vue?vue&type=script&lang=js"
export * from "./PlanCaseIssueList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de3bbec",
  null
  
)

export default component.exports